import {RouteConfig} from "vue-router";
const DashboardView = () => import('../views/dashboard/DashboardView.vue');

let dashboard: RouteConfig[] = [
    {
        name: 'home',
        path: '/',
        component: DashboardView,
        meta: {
            allowLoggedOut: true,
        },
    },
    {
        name: 'dashboard',
        path: '/dashboard',
        redirect: {name: 'home'},
    },
];

export default dashboard;
